import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center justify-center">
        <img 
          src="https://static.readdy.ai/image/356e0a32a00e968a1405b9eb797d2bd9/8d383caa3e7fa492886111d4c9430cb3.jpeg"
          alt="About Us"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="relative z-10 text-center text-white">
          <p className="text-xs tracking-[0.3em] uppercase mb-3">Our Story</p>
          <h1 className="text-5xl md:text-6xl font-light tracking-wide">About Us</h1>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
            <div className="space-y-6">
              <p className="text-xs tracking-[0.3em] text-[#C0392B] uppercase">Our Story</p>
              <h2 className="text-4xl md:text-5xl font-light text-[#2D2D2D] leading-tight">
                Experience the Best of Modern Chinese Cuisine
              </h2>
              <div className="w-12 h-0.5 bg-[#C0392B]"></div>
              <p className="text-base text-[#666666] leading-relaxed">
                At Yummy Lab, we are dedicated to providing our customers with the most delicious and authentic Asian cuisine. Our journey began with a simple passion: to bring the rich flavors and traditions of Chinese cooking to Auckland.
              </p>
              <p className="text-base text-[#666666] leading-relaxed">
                From our selection of mouth-watering hot pot and hand-pulled noodle dishes to our BBQ selections, every dish is made with love and care. We source the finest ingredients and prepare each meal using time-honored techniques passed down through generations.
              </p>
              <p className="text-base text-[#666666] leading-relaxed">
                Our chefs bring decades of experience from various regions of China, ensuring that every bite transports you to the streets of Sichuan, the noodle shops of Lanzhou, or the bustling markets of Beijing.
              </p>
            </div>

            <div className="relative h-[600px]">
              <img 
                src="https://static.readdy.ai/image/356e0a32a00e968a1405b9eb797d2bd9/7ca7067a57cb2d379f5bf004609e05c7.jpeg"
                alt="Chef with Fire"
                className="w-full h-full object-cover object-top rounded-sm"
              />
              <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-[#C0392B]/8 rounded-sm -z-10"></div>
            </div>
          </div>

          {/* Values Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-24">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-[#FDF8F8] rounded-full">
                <i className="ri-heart-line text-3xl text-[#C0392B]"></i>
              </div>
              <h3 className="text-xl font-medium text-[#2D2D2D] mb-3 tracking-wide">Passion</h3>
              <p className="text-sm text-[#666666] leading-relaxed">
                We pour our heart into every dish, ensuring each meal is prepared with genuine care and dedication to authentic flavors.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-[#FDF8F8] rounded-full">
                <i className="ri-leaf-line text-3xl text-[#C0392B]"></i>
              </div>
              <h3 className="text-xl font-medium text-[#2D2D2D] mb-3 tracking-wide">Quality</h3>
              <p className="text-sm text-[#666666] leading-relaxed">
                Only the freshest ingredients make it to your plate. We carefully select premium produce and meats for superior taste.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-[#FDF8F8] rounded-full">
                <i className="ri-group-line text-3xl text-[#C0392B]"></i>
              </div>
              <h3 className="text-xl font-medium text-[#2D2D2D] mb-3 tracking-wide">Community</h3>
              <p className="text-sm text-[#666666] leading-relaxed">
                We believe in bringing people together through food, creating a warm atmosphere where memories are made.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}